function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import * as React from "react";
/**
 * Devuelve todo lo necesario para el correcto manejo del context:
 * 1.El propio context
 * 2.El provider del contexto vitaminado con useReducer para poder modificar el valor con un simple dispatch
 * 3.El consumer
 */

function getContext() {
  var Context = React.createContext();

  var ContextProvider = function ContextProvider(_ref) {
    var children = _ref.children,
        initialState = _ref.initialState,
        reducer = _ref.reducer;

    var _React$useReducer = React.useReducer(reducer, initialState),
        _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
        state = _React$useReducer2[0],
        dispatch = _React$useReducer2[1];

    var value = {
      state: state,
      dispatch: dispatch
    };
    return /*#__PURE__*/React.createElement(Context.Provider, {
      value: value
    }, children);
  };

  var ContextConsumer = Context.Consumer;
  return {
    Context: Context,
    ContextProvider: ContextProvider,
    ContextConsumer: ContextConsumer
  };
}

export default getContext;